import React from 'react';

import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import { getProfileRoute } from 'constants/helper';

function EmployeeClickable({ history, employee, children, component = 'span' }) {
  function onClick() {
    const route = getProfileRoute(employee.id);
    history.push(route);
  }
  return (
    <Container as={component} onClick={onClick}>
      {children}
    </Container>
  );
}

const Container = styled.span`
  cursor: pointer;
`;

export default withRouter(EmployeeClickable);
